/* global axios */
import ApiClient from '../ApiClient';

// Prime Insight — Billing (Stripe): plan/subscription status + checkout/portal.
class MetricaBillingAPI extends ApiClient {
  constructor() {
    super('metrica', { accountScoped: true });
  }

  status() {
    return axios.get(`${this.url}/billing`);
  }

  checkout(tier) {
    return axios.post(`${this.url}/billing/checkout`, {
      tier,
      return_url: window.location.href,
    });
  }

  portal() {
    return axios.post(`${this.url}/billing/portal`, {
      return_url: window.location.href,
    });
  }
}

export default new MetricaBillingAPI();
